/**
 * This file is part of the "Awaken Media" project.
 *
 * (c) 2017 - CanalPlus International
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import React from 'react';

import Arrow from '../core/Arrow';
import { HOURS } from '../../constants';

const sync = {
  centerPadding: 0,
  dots: false,
  infinite: false,
  draggable: false,
  swipe: true,
  swipeToSlide: false,
  speed: 100,
  slidesToShow: (1 / HOURS.length) * 3,
  slidesToScroll: 1 / HOURS.length,
  responsive: [
    {
      breakpoint: 768, // breakpoint.tablet + 1px (since css is doing a max width)
      settings: {
        slidesToShow: (1 / HOURS.length) * 2,
        slidesToScroll: 1 / HOURS.length
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: (1 / HOURS.length) * 1.5,
        slidesToScroll: 1 / HOURS.length
      }
    }
  ]
};

export default {
  days: {
    arrows: true,
    nextArrow: <Arrow />,
    prevArrow: <Arrow />,
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 7,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 993, // breakpoint.tablet + 1px (since css is doing a max width)
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768, // breakpoint.tablet + 1px (since css is doing a max width)
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  },
  hours: {
    arrows: true,
    nextArrow: <Arrow theme="light" />,
    prevArrow: <Arrow theme="light" />,
    ...sync
  },
  programs: {
    arrows: false,
    ...sync
  }
};
